import $router from 'src/router'

export default {
  namespaced: true,
  state: {
    metric: null,
    prevPage: null,
  },
  mutations: {
    SET_METRIC(state, payload) {
      const noRedirect = payload?.noRedirect
      if (noRedirect) {
        delete payload.noRedirect
      }

      state.metric = payload

      if (!noRedirect && payload) {
        $router.toggleQueryParams({
          add: {
            kpi: payload.fullUid,
          },
        })
      }
    },
    SET_PREV_PAGE(state, url) {
      state.prevPage = url
    },
  },
  getters: {
    drillDownQueryKey() {
      return 'kpi'
    },
  },
}
